// axios
import store from '@/store';
import axios from 'axios';
import Vue from 'vue';
import VueCookies from 'vue-cookies';

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
  baseURL: process.env.VUE_APP_ROOT_API,
})

axiosIns.interceptors.request.use(
  config => {
    // Do something before request is sent

    // const accessToken = localStorage.getItem('accessToken')
    const accessToken = VueCookies.get('access_token')

    // eslint-disable-next-line no-param-reassign
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`

    if (store.getters['app/GET_SELECTED_COMPANY_ID']) config.headers.Company = store.getters['app/GET_SELECTED_COMPANY_ID']

    return config
  },
  error => Promise.reject(error),
)

Vue.prototype.$http = axiosIns

export default axiosIns
